import type { GetCourseDraftById200PriceCurrency } from './getCourseDraftById200PriceCurrency';

/**
 * 코스 가격 정보
 * @nullable
 */
export type GetCourseDraftById200Price = {
  /**
   * 가격 (0은 무료)
   * @minimum 0
   */
  amount: number;
  /** 통화 코드 */
  currency: GetCourseDraftById200PriceCurrency;
} | null;
